import React, { useState, useCallback, useEffect } from "react";
import {
  updateDetailsSettings,
  usersDetailsSettings,
} from "../../services/ApiServices";
import ToastMsg from "../../component/comman/ToastMsg";
import { useNavigate } from "react-router-dom";

const PersonalInformation = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState({
    first_name: "",
    last_name: "",
    mobile_no: "",
    email: "",
  });

  useEffect(() => {
    getUsersDetails();
  }, []);

  const getUsersDetails = useCallback(() => {
    usersDetailsSettings()
      .then((res) => {
        if (res.status === 200) {
          setUsers(res.data.data);
          localStorage.setItem("first_name", res.data.data.first_name);
          localStorage.setItem("last_name", res.data.data.last_name);
        } else {
          console.error("API response is not an array:", res?.data);
          setUsers({
            first_name: "",
            last_name: "",
            mobile_no: "",
            email: "",
          });
        }
      })
      .catch((err) => {
        setUsers({
          first_name: "",
          last_name: "",
          mobile_no: "",
          email: "",
        });
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  }, [navigate]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setUsers((prevUsers) => ({
      ...prevUsers,
      [id]: value,
    }));
  };

  const handleSaveUpdates = () => {
    updateDetailsSettings(users)
      .then((res) => {
        if (res.status === 200) {
          ToastMsg("Details updated successfully!", "success");
        } else {
          console.error("Failed to update details:", res?.data);
          ToastMsg("Failed to update details", "error");
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  };

  return (
    <>
      <div className="profile-upper-wrapper">
        <div className="profile-picture">
          <p style={{fontSize:"25px"}}>
            {(users.first_name).charAt(0).toUpperCase()}
            {(users.last_name).charAt(0).toUpperCase()}
          </p>
        </div>
      </div>
      <div className="profile-lower-wrapper text-center">
        <div className="toggle-sc d-flex align-items-center justify-content-center">
          <h3 style={{ textTransform: "capitalize", marginTop:"-20px"}}>
            {users.first_name + " " + users.last_name}
          </h3>
        </div>
        <div className="card">
          <div className="card-body">
            <form>
              <div className="form-group">
                <label htmlFor="first_name">First Name</label>
                <input
                  type="text"
                  id="first_name"
                  value={users.first_name}
                  onChange={handleInputChange}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor="last_name">Last Name</label>
                <input
                  type="text"
                  id="last_name"
                  value={users.last_name}
                  onChange={handleInputChange}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor="mobile_no">Phone</label>
                <input
                  type="number"
                  id="mobile_no"
                  value={users.mobile_no}
                  onChange={handleInputChange}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={users.email}
                  onChange={handleInputChange}
                  className="form-control"
                />
              </div>
            </form>
          </div>
        </div>
        <div className="button-wrapper">
          <button className="btn">Cancel</button>
          <button className="btn" onClick={handleSaveUpdates}>
            Save Updates
          </button>
        </div>
      </div>
    </>
  );
};

export default PersonalInformation;
